import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators, AbstractControl } from '@angular/forms';

import { BaseFormGroup } from '../../../../shared/form-input-components/base-form-group';
import { CommonService } from '../../../../shared/services/common.service';
import { arrayNotEmptyValidator } from '../../../../shared/validators/array-not-empty-validator';
import { pairwise, startWith } from 'rxjs/operators';
import { GoogleMapsService } from 'src/app/shared/services/google-maps.service';
import { TimeValidationService } from 'src/app/bookings/shared/time-validation.service';
import { FormConstants } from '../../../../core/globals/form-constants';
import { DrawerService } from 'mis-crystal-design-system/drawer';
import { BookingSingleDetailsComponent } from 'src/app/bookings/bookings-view/booking-single-details/booking-single-details.component';
import { CreateBookingService } from 'src/app/bookings/create-booking/create-booking.service';


@Component({
  selector: 'app-merge-rider-details',
  templateUrl: './merge-rider-details.component.html',
  styleUrls: ['./merge-rider-details.component.scss']
})
export class MergeRiderDetailsComponent extends BaseFormGroup implements OnInit, OnDestroy {

  @Input() bookings: any[];
  @Input() config: any[];
  @Input() riderMap: any;
  @Input() formArray: FormArray;
  @Input() bookingForm: FormGroup;
  @Input() bookingDetails: any;
  @Input() miscelleneousConfig: any;

  private watchers: any[] = [];
  public loading: boolean;
  public formError = FormConstants.errorMessages.formError;
  public boardingChangeMessage: string;
  public boardingOptions = [
    {
      label: 'Pick Up',
      value: 'PickUp',
      icon: 'assets/pickup.svg'
    },
    {
      label: 'Drop Off',
      value: 'Drop',
      icon: 'assets/drop-point.svg'
    }
  ];
  public savedLocations: any[];
  public stopRidersEditActive = [];
  public riderNameMap: any = {};
  public startRiderConfig: any;
  public addStopConfig: any;
  public removeStopConfig: any;
  public vendorConfig: any;
  public vendorList: any;
  private cutoff: any;
  private airports: any;
  public isStartAirportOnly: boolean;
  public isEndAirportOnly: boolean;
  public allRiders: any[];
  isGenderPresent = false;
  escortGender: string[] = [];
  hasFemaleRider = false;
  isDarkHour = false;
  startTime: string;
  endTime: string;
  showMarshallToast = false;
  disableMarshallInDayHours = false;
  disableMarshallToggle = false;
  onMarshallToggle = false;
  toastMsg = '';
  preRequestedMarshall = false;
  airportDrop = false;
  airportPickup = false;
  busRailwayPickup=false;
  busRailwayDrop=false;
  cityStationMap=[];
  isLoading=false

  constructor(private commonService: CommonService, private googleMapsService: GoogleMapsService,
              private changeDetectorRef: ChangeDetectorRef,
              private timeValidationService: TimeValidationService, private drawerSvc: DrawerService, private createBookingService: CreateBookingService
             ) {
    super();
  }

  ngOnInit() {
    this.createBookingService.genderArrays.subscribe(res => this.escortGender = res);
    this.createBookingService.startTime.subscribe(res => this.startTime = res);
    this.createBookingService.endTime.subscribe(res => this.endTime = res);
    this.commonService.fetchAirports().subscribe((response: any) => {
      this.airports = response;
    });
    this.addStopConfig = this.commonService.getConfigForElementKey(this.config, 'Add Stop');
    this.removeStopConfig = this.commonService.getConfigForElementKey(this.config, 'Remove Stop');
    this.allRiders = Object.values(this.riderMap);
    this.disableMarshallInDayHours = this.miscelleneousConfig?.disableMarshallInDayHours;
    if (this.disableMarshallInDayHours) { this.disableMarshallToggle = true; }

    for (let stopIndex = 0; stopIndex < this.formArray.length; stopIndex++) {
      const stop = this.formArray.at(stopIndex);
      const stopRiders = stop.get('riders') as FormArray;
      for (const riderControl of stopRiders.controls) {
        const riderFormGroup = riderControl as FormGroup;
        const genderControl = riderFormGroup.get('gender').value;

        // gender config
        if (genderControl && this.escortGender.includes(genderControl) ) {
          this.hasFemaleRider = true;
        }
      }

      this.stopRidersEditActive.push(true);
      if (stop instanceof FormGroup) {
        if (stopIndex === 0) {
          this.commonService.fetchCutoff().subscribe((cutoffRespnse: any) => {
            const validators = [Validators.required];
            this.cutoff = cutoffRespnse;
            validators.push(this.pickupTimeValidate.bind(this, stop));
            validators.push(this.timeValidationService.mergeStopTimeValidator.bind(this, this.formArray));
            stop.get('time').setValidators(validators);
          });
          stop.get('address').setValidators([this.handleBookingTypeChangeInStart]);
        } else if (stop.get('time')) {
          this.watchers.push(
            stop.get('time').valueChanges.pipe(startWith(null), pairwise())
            .subscribe(this.timeValidationService.mergeStopTimeValidator.bind(this, this.formArray))
          );
        }

        if (stopIndex === this.formArray.length - 1) {
          stop.get('time').setValidators(null);
          stop.get('address').setValidators([this.handleBookingTypeChangeInEnd]);
        }

        this.watchers.push(
          stop.get('address').valueChanges.pipe(startWith(null), pairwise()).subscribe(
            this.cabStopsValidator.bind(this, this.formDetails))
        );
      }
      this.markFormGroupDirty(this.formArray);
      this.formArray.updateValueAndValidity();
    }


    this.commonService.getSavedLocations().subscribe((response: any[]) => {
      this.savedLocations = response;
    });
    for (const booking of this.bookings){
      if (booking.guardReq){
        this.preRequestedMarshall = true;
        break;
      }
    }
    this.setBusRailwayData()
  }

  setBusRailwayData() {
    const bookingType = this.bookingForm.get('spotBookingType')?.value;
    if(bookingType==='Bus Station Pickup' || bookingType === 'Railway Station Pickup')
    {
      this.busRailwayPickup=true;
      this.getTransPortData(this.bookings[0].city,bookingType)
    }
    else if(bookingType==='Bus Station Drop' || bookingType === 'Railway Station Drop')
    {
      this.busRailwayDrop=true;
      this.getTransPortData(this.bookings[0].city,bookingType)
    }
  }

  isTimeInRange(startTime, endTime, timeToCheck) {
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const [endHour, endMinute] = endTime.split(':').map(Number);
    const [checkHour, checkMinute] = timeToCheck.split(':').map(Number);

    if (endHour < startHour || (endHour === startHour && endMinute < startMinute)) {
      return (
            (checkHour < endHour || (checkHour === endHour && checkMinute <= endMinute)) ||
            (checkHour > startHour || (checkHour === startHour && checkMinute >= startMinute))
        );
    } else {
      return (
            (checkHour > startHour || (checkHour === startHour && checkMinute >= startMinute)) &&
            (checkHour < endHour || (checkHour === endHour && checkMinute <= endMinute))
        );
    }
    }

  handleBookingTypeChangeInStart = (control) => {
    if (this.bookingDetails.spotBookingType === 'Airport PickUp') {
      if (control.value && !control.value.isAirport) {
        return {
          airportRequired: true
        };
      }
    }
    return null;
  }

  handleBookingTypeChangeInEnd = (control) => {
    if (this.bookingDetails.spotBookingType === 'Airport Drop') {
      if (control.value && !control.value.isAirport) {
        return {
          airportRequired: true
        };
      }
    }
    return null;
  }

  pickupTimeValidate = (stop, control) => {
    return this.timeValidationService.pickupTimeValidator(stop.get('date'), this.cutoff.cutOffMins, control);
  }
  timeChangeCallback(e){
    this.isDarkHour = this.isTimeInRange(this.startTime, this.endTime, e);
    if (this.isDarkHour && this.hasFemaleRider ){
      this.showMarshallToast = true;
      this.disableMarshallToggle = true;
      this.onMarshallToggle = true;
      this.marshallToastHandeller("Dark hours travel, marshal automatically assigned.");
    } else{
      this.onMarshallToggle = false;
      this.disableMarshallInDayHours ? this.disableMarshallToggle = true : this.disableMarshallToggle = false;
    }
  }

  marshallToastHandeller(msg){
    this.toastMsg = msg;
    setTimeout(() => {
      this.showMarshallToast = false;

  }, 3000);
  }

  addStop(index: number) {
    const stopFormGroup = this.createStopForm();
    const stops = this.formArray;
    stopFormGroup.get('date').setValue(stops.at(index - 1).get('date').value);
    if (stops instanceof FormArray) {
      stops.insert(index, stopFormGroup);
    }
    this.stopRidersEditActive.splice(index, 0, false);

    if (stopFormGroup.get('time') instanceof FormControl) {
      this.watchers.push(
        stopFormGroup.get('time').valueChanges.pipe(startWith(null), pairwise())
          .subscribe(this.timeValidationService.mergeStopTimeValidator.bind(this, stops))
      );
    }

    this.watchers.push(
      stopFormGroup.get('address').valueChanges.pipe(startWith(null), pairwise()).subscribe(
          this.cabStopsValidator.bind(this, this.formDetails))
    );
  }

  removeStop(index: number) {
    const stops = this.formArray;
    if (stops instanceof FormArray) {
      stops.removeAt(index);
    }
    this.stopRidersEditActive.splice(index, 1);
  }

  createStopForm() {
    return new FormGroup({
       riders: new FormArray([], [arrayNotEmptyValidator]),
       time: new FormControl('', [Validators.required]),
       address: new FormControl('', [Validators.required]),
       date: new FormControl('', [Validators.required]),
    });
  }

  addRider(stopForm: FormGroup, stopIndex: number, riderPatch?: any) {
    const riderFormGroup = this.createRiderForm();
    if (riderPatch) {
      riderFormGroup.patchValue(riderPatch);
    }
    if (stopIndex === 0) {
      if (!riderFormGroup.get('boardingType').value) {
        riderFormGroup.get('boardingType').setValue(this.boardingOptions[0].value);
      }
      riderFormGroup.get('boardingType').disable();
    }

    const riders = stopForm.get('riders');
    if (riders instanceof FormArray) {
      riders.push(riderFormGroup);
    }
  }

  createRiderForm() {
    return new FormGroup({
      name: new FormControl('', [Validators.required]),
      mobile: new FormControl(''),
      boardingType: new FormControl('', [Validators.required])
    });
  }

  removeRider(riderIndex: number, stopForm: FormGroup) {
    const riders = stopForm.get('riders');
    if (riders instanceof FormArray) {
      riders.removeAt(riderIndex);
    }
  }

  toggleRidersView(stopIndex: number) {
    this.stopRidersEditActive[stopIndex] = !this.stopRidersEditActive[stopIndex];
  }

  getBoardingLabel(boarding: any): string {
    return boarding.label;
  }

  getBoardingValue(boarding: any): string {
    return boarding.value;
  }

  getImageFromValue = (boarding: any) => {
    for (const option of this.boardingOptions) {
      if (option.value === boarding) {
        return option.icon;
      }
    }
  }

  getRiderLabel(rider: any): string {
    return rider.name;
  }

  getRiderValue(rider: any): string {
    return rider.uniqueEmpId || rider.name;
  }

  onRiderChange = (rider: FormGroup, stopIndex: number) => {
    if (!rider.get('name').value) {
      return;
    }

    for (const user of  this.allRiders) {
      if (rider.get('name').value === user.uniqueEmpId) {
        rider.get('mobile').setValue(user.mobile);
      }
    }

    const stops = this.formArray;
    const matchesFound = [];

    if (stops instanceof FormArray) {

      for (let sIndex = 0; sIndex < stops['length'] - 1; sIndex++) {
        const stopRiders = stops.at(sIndex).get('riders');
        if (sIndex === stopIndex) {
          continue;
        }
        for (let rIndex = 0; rIndex < stopRiders['length']; rIndex++) {
          const stopRider = stopRiders instanceof FormArray && stopRiders.at(rIndex);
          if (rider.get('name').value === stopRider.get('name').value) {
            matchesFound.push({
              stopIndex: sIndex,
              riderIndex: rIndex,
              boardingType: stopRider.get('boardingType').value,
              riderForm: stopRider
            });
            break;
          }
        }
      }

      const boardingControl = rider.get('boardingType');

      if (!boardingControl.value) {
        if (!matchesFound.length || stopIndex < matchesFound[0].stopIndex) {
          boardingControl.setValue(this.boardingOptions[0].value);
        } else if (stopIndex > matchesFound[matchesFound.length - 1].stopIndex) {
          boardingControl.setValue(this.boardingOptions[1].value);
        }
      }

      if (boardingControl.value && matchesFound.length) {
        for (const match of matchesFound) {
          if (boardingControl.value === match.boardingType) {
            const riders = stops.at(match.stopIndex).get('riders');
            if (riders instanceof FormArray) {
              riders.removeAt(match.riderIndex);
            }
            // tslint:disable-next-line: max-line-length
            const stopDescription = stopIndex === 0 ? 'start point' : ((stopIndex === stops['length']) ? 'end point' : ('stop ' + stopIndex));
            this.boardingChangeMessage = `${boardingControl.value} of rider changed to ${stopDescription}`;
          }
        }
      }
    }
  }

  clearBoardingChangeMessage() {
    this.boardingChangeMessage = '';
  }

  showError(formGroup: FormGroup) {
    return Boolean(formGroup && formGroup.dirty && formGroup.invalid);
  }

  getLocationLabel = (location: any) => {
    return location.address;
  }

  stopGeoCordValidator(city: string, stopForm: AbstractControl) {
    const address = stopForm.get('address');
    if (address.value && (address.value.geoCord || address.value.city)) {
      this.googleMapsService.checkLocationInCity(city, address.value).subscribe((response) => {
        if (!response) {
          address.setErrors({
            outsideBounds: true
          });
        } else {
          address.setErrors(null);
        }
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  cabStopsValidator(cabForm: FormGroup) {

    const sourceCity = this.bookings[0].city;
    const destinationCity = this.bookings[0].destinationCity;
    const bookingType = this.bookingDetails.spotBookingType;
    const stops = this.formArray;

    if (stops instanceof FormArray && stops.length) {

      if (bookingType && (bookingType.toLowerCase().includes('outstation'))) {
        if (sourceCity) {
          this.stopGeoCordValidator(sourceCity, stops.at(0));
        }
        if (destinationCity) {
          this.stopGeoCordValidator(destinationCity, stops.at(stops.length - 1));
        }
      } else {
        if (sourceCity) {
          for (let i = 0; i < stops.length; i++) {
            const stop = stops.at(i);
            this.stopGeoCordValidator(sourceCity, stop);
          }
        }
      }
    }
  }

  setEndStopValidator = () => {
    const endStopFrom = this.formArray.at(this.formArray.length - 1);
    if (this.bookingDetails.spotBookingType === 'cab at disposal') {
      endStopFrom.get('address').setValidators(null);
    } else {
      endStopFrom.get('address').setValidators([Validators.required]);
    }
    endStopFrom.get('address').updateValueAndValidity();
  }

  getCityBoundForStop(stopIndex: number) {
    const sourceCity = this.bookings[0].city;
    const destinationCity = this.bookings[0].destinationCity;
    const bookingType = this.bookingDetails.bookingType;

    if (bookingType && bookingType.toLowerCase().includes('outstation')) {
      return stopIndex === this.formArray.length - 1 ? destinationCity : sourceCity;
    } else {
      return sourceCity;
    }
  }

  getSavedLocations = (stopIndex: number) => {
    const stops = this.formArray;
    const bookingType = this.bookingForm.get('spotBookingType');
    const isBusStationPickup = bookingType.value?.toLowerCase() === 'Bus Station Pickup'.toLowerCase();
    const isBusStationDrop = bookingType.value?.toLowerCase() === 'Bus Station Drop'.toLowerCase();
    const isRailwayStationPickup = bookingType.value?.toLowerCase() === 'Railway Station Pickup'.toLowerCase();
    const isRailwayStationDrop = bookingType.value?.toLowerCase() === 'Railway Station Drop'.toLowerCase();
    if (stops instanceof FormArray) {
      if (stopIndex === 0 && bookingType.value === 'Airport PickUp') {
        this.airportPickup = true;
        return this.airports;
      } else if (stopIndex === stops.length - 1 && bookingType.value === 'Airport Drop') {
        this.airportDrop = true;
        return this.airports;
      }
      else if ((stopIndex === 0 && (isBusStationPickup || isRailwayStationPickup)) ||
      (stopIndex === stops.length - 1 && (isBusStationDrop || isRailwayStationDrop))) {
    return this.cityStationMap;
  }
    }
    return this.savedLocations;
  }

  getStopLabel = (stopIndex) => {
    return (stopIndex === 0 ? 'Start Address' : (stopIndex === this.formArray.length - 1 ? 'End Address' : 'Stop ')) +
              (stopIndex > 0 && stopIndex < this.formArray.length - 1 ? stopIndex : '');
  }

  openDetailsSidebar(booking){
    const drawerRef = this.drawerSvc.show(
      BookingSingleDetailsComponent,
      { data: booking,
        miscelleneousConfig: this.miscelleneousConfig,
        showOtpProperty :  this.commonService.workflowConfig['showOTPOnDashboard'] },
      { width: "422px" }
    );
    drawerRef.afterClosed.subscribe(console.log);

  }
  moveStopDown(index){
    if (index < this.formArray.controls.length - 1) {
      this.swap(this.formArray, index, index + 1);
      const lastFormGroup = this.formArray.at(this.formArray.controls.length - 1) as FormGroup;
      const timeControl = lastFormGroup.get('time');
      timeControl.clearValidators();
      timeControl.updateValueAndValidity();
      const ridersControl = lastFormGroup.get('riders');
      ridersControl.clearValidators();
      ridersControl.updateValueAndValidity();
    }
    }

    getTransPortData(city:string,bookingType:string)
    {
      this.isLoading=true;
      this.commonService.getTransportData(city,bookingType).subscribe((res)=>{
        this.cityStationMap=[]
        this.isLoading=false;
        res.forEach((cityStation)=>{
          cityStation.isSaved = true;
          cityStation.isBusRailway = true;
          cityStation.city = city;
          this.cityStationMap.push(cityStation);
        })
      },
      (error)=>{
        this.isLoading=false;
        this.cityStationMap=[]
      }
      )
    }

  moveStopUp(index){
    if (index >= 1) {
    this.swap(this.formArray, index, index - 1);
    }
  }
   swap(array: FormArray, x: any, y: any) {
    const b = array.at(x);
    array.setControl(x, array.at(y));
    array.setControl(y, b);
  }
  ngOnDestroy() {
    this.watchers.forEach((watcher) => {
      watcher.unsubscribe();
    });
  }
}

